import { render, staticRenderFns } from "./FenceDescription.vue?vue&type=template&id=370f7348&scoped=true"
import script from "./FenceDescription.vue?vue&type=script&lang=ts"
export * from "./FenceDescription.vue?vue&type=script&lang=ts"
import style0 from "./FenceDescription.vue?vue&type=style&index=0&id=370f7348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f7348",
  null
  
)

export default component.exports